import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {CustomsValidators} from '../../validators/custom.validators';
import {throwError} from 'rxjs';


@Injectable()
export class SeeAllRequestService {

  urlSee: string;

  constructor(private http: HttpClient) {
    this.urlSee = `${environment.bffBaseUrl}/pages/requests`;
  }

  getAllRequest(page, limit) {
    const urlBuilder = `${this.urlSee}?page=${page}&limit=${limit}`;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }
}

export interface Request {
  Status: string;
  RequestNumber: number;
  RequestDate: string;
}



